import Vue from 'vue';

/**
 * Class Insight Service
 */
export default class InsightService extends Vue {

    private customActions = {
        add_insight: { method: 'POST', url: 'auth/insight' },
        edit_insight: { method: 'PUT', url: 'auth/insight/{id_insight}' },
    };
    private resource: any = this.$resource('auth/insight{/id}', {}, this.customActions);

    // POST add insight
    public add_insight(data: any) {
        return this.resource.add_insight({}, data).then((response: any) => {
            return response.json();
        }, (response: any) => {
            return response.json();
        });
    }

    // PUT edit insight
    public edit_insight(id_insight: number, data: any) {
        return this.resource.edit_insight({ id_insight }, data).then((response: any) => {
            return response.json();
        }, (response: any) => {
            return response.json();
        });
    }
}
